var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H18V.563A.564.564 0 0 0 17.438 0h-1.875A.564.564 0 0 0 15 .563V3H9V.563A.564.564 0 0 0 8.438 0H6.562A.564.564 0 0 0 6 .563V3H3.75A2.25 2.25 0 0 0 1.5 5.25v16.5A2.25 2.25 0 0 0 3.75 24h16.5a2.25 2.25 0 0 0 2.25-2.25V5.25A2.25 2.25 0 0 0 20.25 3m-.281 18.75H4.03a.28.28 0 0 1-.281-.281V7.5h16.5v13.969a.28.28 0 0 1-.281.281"
  })));
};
export default SvgCalendar;